module.exports = __webpack_public_path__ + "static/page-header-1-1-240a6442830113da09227d9b147a94a4.jpg";